module.exports = __webpack_public_path__ + "static/work-1-32237dddf4fcb46ac5f8978fb604f9a3.jpg";